import React, { useCallback, useEffect, useState } from "react";
// import { Result } from 'antd';
// import { Icon } from 'semantic-ui-react';
// // import { MehOutlined } from '@ant-design/icons';
import axios from "axios";
import "./styles.scss";
import { connect } from "react-redux";
import Loader from "../../../Global/Loader";
import NoAccesoBI from "./NoAccesoBI.png";

function BiGerencial() {
  const ref = React.useRef(null);
  const [urlTableau, setUrlTableau] = useState("");
  const [fullLoader, setFullLoader] = useState(false);
  React.useEffect(() => {
    /*const token = jwt.sign(
      { userId: props.Email, projectId: "5" },
      "ebfac685eee1abaecf728dfea0a78750",
      { expiresIn: 60 * 60 }
    );*/
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const url =
          "https://prod-mlg-tableau-auth-api.azurewebsites.net/api/v1/tableau/trusted";
        const options = {
          headers: {
            "x-api-key": "ca06a2a6-43e8-4672-9b7d-8f0724c55d04",
            "x-access-token": token,
          },
        };
        const res = await axios.get(url, options);

        setUrlTableau(res.data.data.plainUrl);
        setFullLoader(true);
      } catch (error) {
        setUrlTableau("");
        setFullLoader(true);
      }
    };

    fetchData();
  }, []);

  return (
    <React.Fragment>
      <div class="embed-container">
        <Loader hidden={fullLoader} />
        {urlTableau == "" ? (
          <div class="d-flex justify-content-center">
            <img
              src={NoAccesoBI}
              style={{ maxWidth: "100%", height: "90vh" }}
            ></img>
          </div>
        ) : (
          <iframe
            // src="https://ig-analytics.com/"
            src={urlTableau}
            frameborder="0"
            allowfullscreen
          ></iframe>
        )}
      </div>
    </React.Fragment>
  );
}
/*const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BiGerencial);*/

export default BiGerencial;
